export const ADD_SPACE_GROUP_MEMBERS_FORM_ID = "add-space-group-members-form";

export interface AddSpaceGroupMemberContentCompassFormValues {
  add_all_members: boolean;
  community_member_ids: string[] | null;
}

export const ADD_SPACE_GROUP_MEMBERS_DEFAULT_VALUES: AddSpaceGroupMemberContentCompassFormValues =
  {
    add_all_members: false,
    community_member_ids: null,
  };

export interface AddSpaceGroupMemberModalProps {
  queryKey?: unknown[];
  spaceGroupId: number;
}
